/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateSkillVersionFiles = {
  fileName: string;
  content: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

export type CreateSkillVersionRequestBody = {
  /**
   * Skill version files to upload (must include SKILL.md)
   */
  files?: Array<CreateSkillVersionFiles> | undefined;
  /**
   * Set this version as the default
   */
  default?: boolean | undefined;
};

export type CreateSkillVersionRequest = {
  skillId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody: CreateSkillVersionRequestBody;
};

/** @internal */
export const CreateSkillVersionFiles$inboundSchema: z.ZodType<
  CreateSkillVersionFiles,
  z.ZodTypeDef,
  unknown
> = z.object({
  fileName: z.string(),
  content: z.union([
    z.instanceof(ReadableStream<Uint8Array>),
    z.instanceof(Blob),
    z.instanceof(ArrayBuffer),
    z.instanceof(Uint8Array),
  ]),
});
/** @internal */
export type CreateSkillVersionFiles$Outbound = {
  fileName: string;
  content: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export const CreateSkillVersionFiles$outboundSchema: z.ZodType<
  CreateSkillVersionFiles$Outbound,
  z.ZodTypeDef,
  CreateSkillVersionFiles
> = z.object({
  fileName: z.string(),
  content: z.union([
    z.instanceof(ReadableStream<Uint8Array>),
    z.instanceof(Blob),
    z.instanceof(ArrayBuffer),
    z.instanceof(Uint8Array),
  ]),
});

export function createSkillVersionFilesToJSON(
  createSkillVersionFiles: CreateSkillVersionFiles,
): string {
  return JSON.stringify(
    CreateSkillVersionFiles$outboundSchema.parse(createSkillVersionFiles),
  );
}
export function createSkillVersionFilesFromJSON(
  jsonString: string,
): SafeParseResult<CreateSkillVersionFiles, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateSkillVersionFiles$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateSkillVersionFiles' from JSON`,
  );
}

/** @internal */
export const CreateSkillVersionRequestBody$inboundSchema: z.ZodType<
  CreateSkillVersionRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  files: z.array(z.lazy(() => CreateSkillVersionFiles$inboundSchema))
    .optional(),
  default: z.boolean().optional(),
});
/** @internal */
export type CreateSkillVersionRequestBody$Outbound = {
  files?: Array<CreateSkillVersionFiles$Outbound> | undefined;
  default?: boolean | undefined;
};

/** @internal */
export const CreateSkillVersionRequestBody$outboundSchema: z.ZodType<
  CreateSkillVersionRequestBody$Outbound,
  z.ZodTypeDef,
  CreateSkillVersionRequestBody
> = z.object({
  files: z.array(z.lazy(() => CreateSkillVersionFiles$outboundSchema))
    .optional(),
  default: z.boolean().optional(),
});

export function createSkillVersionRequestBodyToJSON(
  createSkillVersionRequestBody: CreateSkillVersionRequestBody,
): string {
  return JSON.stringify(
    CreateSkillVersionRequestBody$outboundSchema.parse(
      createSkillVersionRequestBody,
    ),
  );
}
export function createSkillVersionRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<CreateSkillVersionRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateSkillVersionRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateSkillVersionRequestBody' from JSON`,
  );
}

/** @internal */
export const CreateSkillVersionRequest$inboundSchema: z.ZodType<
  CreateSkillVersionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => CreateSkillVersionRequestBody$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type CreateSkillVersionRequest$Outbound = {
  skill_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody: CreateSkillVersionRequestBody$Outbound;
};

/** @internal */
export const CreateSkillVersionRequest$outboundSchema: z.ZodType<
  CreateSkillVersionRequest$Outbound,
  z.ZodTypeDef,
  CreateSkillVersionRequest
> = z.object({
  skillId: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => CreateSkillVersionRequestBody$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function createSkillVersionRequestToJSON(
  createSkillVersionRequest: CreateSkillVersionRequest,
): string {
  return JSON.stringify(
    CreateSkillVersionRequest$outboundSchema.parse(createSkillVersionRequest),
  );
}
export function createSkillVersionRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateSkillVersionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateSkillVersionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateSkillVersionRequest' from JSON`,
  );
}
